import React from 'react'
import { DiscountApplyToType, UiConfigDiscountType, CouponType } from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import BundlePricingInputs from './BundlePricingInputs'
import BundleSelectedResources from './BundleSelectedResources'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import DiscountInfoText from '../../../common/DiscountInfoText'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountApplicationRulesBundle = () => {
  const {
    state: { uiConfig: rawUiConfig, entitlement }
  } = useDiscountForm()
  const { t } = useLocale()

  if (rawUiConfig.type !== UiConfigDiscountType.BUNDLE) return null

  if (entitlement.type !== CouponType.BUNDLE) return null

  const applyTo = entitlement.applyTo

  const renderBundleDiscountInfo = () => {
    if (applyTo === DiscountApplyToType.ALL_PRODUCTS) return null

    const infoText =
      applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS
        ? t('discounts_v2.bundle_collection_info')
        : t('discounts_v2.bundle_product_info')

    const hasProducts = entitlement.entitledCatalogue?.some(group => group?.entities?.length > 0) || false

    return <DiscountInfoText text={infoText} show={hasProducts} />
  }

  return (
    <div className='flex flex-col gap-4 w-full'>
      <div className='flex flex-col gap-3'>
        <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_bundle_price')}</h3>
        <BundlePricingInputs />
      </div>

      {renderBundleDiscountInfo()}

      <BundleSelectedResources />

      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesBundle
